// Phase — Reports Dashboard. Thin Card wrapper every chart widget sits in, so
// spacing/title/empty-state handling stays identical across all charts.
import * as React from "react";
import { Card, CardContent } from "ui/card";
import { Skeleton } from "ui/skeleton";
import { EmptyState } from "../../../shared/empty-state";
import { cn } from "lib/utils";

export interface ChartCardProps {
  title: React.ReactNode;
  loading?: boolean;
  isEmpty?: boolean;
  className?: string;
  /** Overrides the default fixed h-64 body height (e.g. "h-auto sm:h-64"). */
  bodyClassName?: string;
  children: React.ReactNode;
}

export function ChartCard({ title, loading, isEmpty, className, bodyClassName, children }: ChartCardProps) {
  return (
    <Card className={cn("shadow-sm", className)}>
      <CardContent className="p-4">
        <h3 className="mb-3 text-sm font-semibold text-foreground">{title}</h3>
        {loading ? (
          <Skeleton className="h-64 w-full" />
        ) : isEmpty ? (
          <div className="flex h-64 items-center justify-center">
            <EmptyState title="No data yet" description="Nothing to show for the selected date range." />
          </div>
        ) : (
          <div className={cn("w-full", bodyClassName ?? "h-64")}>{children}</div>
        )}
      </CardContent>
    </Card>
  );
}

export default ChartCard;
